import { render, staticRenderFns } from "./mobile144.vue?vue&type=template&id=556f4ba6&"
import script from "./mobile144.vue?vue&type=script&lang=js&"
export * from "./mobile144.vue?vue&type=script&lang=js&"
import style0 from "./mobile144.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports